export enum PaymentStatus {
    approved = 'approved',
    rejected = 'rejected',
    pending = 'pending'
}
